import { useEffect, useState } from "react";
import { useApiGet } from "../../../api/apiCall";
import { getRecentNoticessUrl } from "../../../api/urls";
import { GlobalMenu, MessageBox } from "../../../ui_elements";
import { LandingModal } from "./containers";
import DOMPurify from "dompurify";
import Hero from "../../../assets/svgs/Rectangle 137.svg";
import { Link } from "react-router-dom";

import styles from "./styles.module.css";
import { APPLICATION_ID, APPLICATION_MODE } from "../../../utils/constants";
import { ArrowUp } from "../../../assets/svgs";
import NotificationBanner from "./banner";
const date = new Date();

const Home = () => {
	const [message, setMessage] = useState(true);
	const [modal, setModal] = useState(false);
	const handleCurrentLink = (linkObject) => {
		if (linkObject?.applicationMode === APPLICATION_MODE.UTME) {
			return {
				pathname: `/generate_jamb_students_invoice`,
				state: { application: linkObject }
			};
		} else {
			return {
				pathname: `/generate_jamb_students_invoice`,
				state: { application: linkObject }
			};
		}
	};

	const applicationForms = [
		{
			applicationMode: APPLICATION_MODE.UTME,
			id: APPLICATION_ID.UTME,
			name: "DEGREE",
			Link: "/putme_login"
		},

		{
			applicationMode: APPLICATION_MODE.DIPLOMA,
			id: APPLICATION_ID.DIPLOMA,
			name: "Post Basic Nursing",
			Link: "#"
		},
		{
			applicationMode: APPLICATION_MODE.DIPLOMA,
			id: APPLICATION_ID.DIPLOMA,
			name: "Postgraduate",
			Link: "#"
		},
		{
			applicationMode: APPLICATION_MODE.SUPPLEMENTARY,
			id: APPLICATION_ID.SUPPLEMENTARY,
			name: "Supplementary Applications",
			Link: "#"
		},
		{
			applicationMode: APPLICATION_MODE.INTER_UNIVERSITY_TRANSFER,
			id: APPLICATION_ID.INTER_UNIVERSITY_TRANSFER,
			name: "Inter University Transfer",
			Link: "/uni_transfer_login"
		},
		{
			applicationMode: APPLICATION_MODE.DIRECT_ENTRY,
			id: APPLICATION_ID.DIRECT_ENTRY,
			name: "Direct Entry",
			Link: "/direct_entry_login"
		}
	];
	const { data, isFetched } = useApiGet(getRecentNoticessUrl(), {
		keepPreviousData: true
	});

	useEffect(() => {
		if (isFetched) {
			setModal(true);
		}
	}, [isFetched]);

	// const handleScroll = () => {
	// 	window.scrollTo(0, document.body.scrollHeight);
	// };

	// const {
	// 	data: applications,
	// 	isLoading,
	// 	error
	// } = useApiGet(getAllApplicationTypesUnpaginatedUrl());

	// const random = (array) => {
	// 	if (array?.length > 0) {
	// 		const arrayIndex = Math.floor(Math.random(3.32) * array.length);
	// 		return array[arrayIndex];
	// 	}
	// };

	// useEffect(() => {
	// 	setCurrentApplication(
	// 		random(applications?.data?.filter((item) => item.active))
	// 	);
	// }, [applications?.data]);

	// if (isLoading) return <PageLoader />;
	// if (error)
	// 	return "An error has occurred: " + error?.response?.data?.message;

	return (
		<>
			{!data?.data || data?.data.length === 0 ? null : (
				<LandingModal
					data={data?.data}
					isOpen={modal}
					closeModal={() => setModal(false)}
				/>
			)}
			{!data?.data ||
			data?.data?.length === 0 ||
			message === false ? null : (
				<MessageBox
					openModal={() => setModal(true)}
					closeMessage={setMessage}
					title={data?.data[0]?.title}
					message={
						<div
							className={`d-flex align-items-baseline ${styles.message_body}`}
						>
							<div
								dangerouslySetInnerHTML={{
									__html: DOMPurify.sanitize(
										data?.data[0]?.description.slice(0, 70)
									)
								}}
							/>
							<span>....</span>
						</div>
					}
				/>
			)}
			<GlobalMenu isLanding={"unAuthenticated"} />
			<NotificationBanner />
			<main className={`${styles.container}`}>
				<div className={styles.firstCover}>
					<div className={styles.sectionsContainer}>
						<section className="d-flex flex-column justify-content-center w-100 justify-content-md-center  align-items-center">
							<div className="px-5">
								<h1>
									Welcome to Federal University of Allied
									Health Sciences, Portal.
								</h1>
								<p className="mb-4">
									Navigate your academic journey with ease.
									Stay informed, organized, and achieve your
									goals.
								</p>
							</div>
							<div className={styles.landing_sect}>
								<img src={Hero} alt="" />
							</div>
						</section>
					</div>
				</div>
			</main>
			<div className={styles.application_section_container}>
				<div className={`mb-5 ${styles.application_section_header}`}>
					<h2 className={`pb-1 ${styles.programme}`}>
						Our Programmes
					</h2>
					<p>
						Explore a World of Learning Possibilities: Discover Our
						Diverse Academic Pathways
					</p>
				</div>

				<div className={styles.application_section_container_cards}>
					{applicationForms.map((applicationForm) => (
						<ApplicationCard
							handleCurrentLink={handleCurrentLink}
							applicationForm={applicationForm}
						/>
					))}
				</div>
				{/* <ApplicationTabs items={applicationTabsInfo} /> */}
			</div>
			<footer
				className={`d-flex flex-column align-items-center justify-content-center mt-5 ${styles.home_footer}`}
			>
				{/* <p className={`${styles.call_centre_number}`}>
					Need help? <span>-</span> <span>08139833300</span>
				</p> */}
				<p>
					{`Copyright©️ ${date.getFullYear()} All rights reserved by Federal University of
					Allied Health Sciences, Enugu . Powered by Tenece`}
				</p>
				<div
					className={`${styles.fab} d-flex align-items-center justify-content-center`}
					onClick={() =>
						window.scrollTo({
							top: 0,
							behavior: "smooth"
						})
					}
				>
					<ArrowUp />
				</div>
			</footer>
		</>
	);
};

export default Home;

const ApplicationCard = ({ handleCurrentLink, applicationForm }) => {
	return (
		<div className={styles.application_card}>
			<h3 className={styles.program_text}>{applicationForm?.name}</h3>
			<p className={`${styles.program_text} text-left mt-1`}>
				Please select a link applicable to you from the list below
			</p>
			<div className={`${styles.cardLinks} `}>
				<Link to={() => handleCurrentLink(applicationForm)}>
					Generate Invoice
				</Link>
				<Link to={() => applicationForm.Link}>Application Form</Link>
			</div>
		</div>
	);
};
